import React, { useContext } from 'react';
import classnames from 'classnames';

import Button from '../../components/Button';
import {
  UnitPageContext,
  UnitPageContextInterface,
} from '../../pages/[urlParam]/[urlBuildParam]/[urlUnitParam]';
import { createSearchUrlByType } from '../Search/utils/listingsFiltersUtils';
import { Box, Divider, Skeleton, Typography } from '@mui/material';

import CondoCard from 'components/Search/CondosSearchResult/CondoCard';
import ErrorBoundary from 'components/ErrorBoundary';
import { getPropertyTypeByCode } from 'src/utils/getPropertyTypeByCode';
import LineBetweenSections from 'components/LineBetweenSections';
import ResponsiveCarousel from '../common/ResponsiveCarousel';

type propsAboutSection = {
  isPPC?: boolean;
  isIconPPC?: boolean;
};

const AboutSection: React.FC<propsAboutSection> = ({ isPPC, isIconPPC }) => {
  const {
    listing,
    nearbyCondos,
    neighborhood,
    nearbyCondosTotal,
    nearbyCondosLoading,
  } = useContext(UnitPageContext) as UnitPageContextInterface;

  const Preloader = () => (
    <>
      {new Array(1).fill(null).map((_, i) => (
        <Box pt={3} key={i}>
          {new Array(10).fill(null).map((__, j) => (
            <Typography key={j} variant="h3">
              <Skeleton />
            </Typography>
          ))}
          <Divider sx={{ marginTop: 3 }} />
        </Box>
      ))}
    </>
  );

  return (
    <ErrorBoundary>
      {/*{neighborhood?.shortDescription && (*/}
      {/*  <section className="container pt-[38px] md:pt-[30px]">*/}
      {/*    <div className="flex ">*/}
      {/*      <div className="items-center justify-center hidden w-10 mx-2 md:flex lg:w-16">*/}
      {/*        <div className="w-10 lg:w-16 h-0.5 bg-black"/>*/}
      {/*      </div>*/}
      {/*      <div*/}
      {/*        className="justify-center text-24-32-0.3  uppercase whitespace-pre-line w-max lg:text-30-36-1 md:mx-4 font-sohneBreitBuch">*/}
      {/*        <button className="flex items-start text-left uppercase">*/}
      {/*          <div className="block w-8 mr-1 md:hidden">*/}
      {/*            <Image src={arrowDown} alt="About"/>*/}
      {/*          </div>*/}
      {/*          <h2 className="whitespace-pre-line">*/}
      {/*            About&nbsp;*/}
      {/*            {neighborhood.name}*/}
      {/*          </h2>*/}
      {/*        </button>*/}
      {/*      </div>*/}
      {/*    </div>*/}
      {/*    <div className="relative mt-6 md:mt-[6px] ellipsis md:leading-6 md:pr-1 lg:leading-7 xl:w-1/2">*/}
      {/*      <div*/}
      {/*        className={classnames('max-h-20 lg:max-h-40 h-0', {*/}
      {/*          'h-30 md:h-40': neighborhood?.shortDescription,*/}
      {/*        })}*/}
      {/*      >*/}
      {/*        {neighborhood.shortDescription && (*/}
      {/*          <MarkdownParser*/}
      {/*            markdown={neighborhood.shortDescription}*/}
      {/*            classNames="text-16-26-0.3"*/}
      {/*          />*/}
      {/*        )}*/}
      {/*        <div*/}
      {/*          className="absolute bottom-0 w-full h-10"*/}
      {/*          style={{*/}
      {/*            background: 'linear-gradient(rgba(255,255,255,0),#fff)',*/}
      {/*          }}*/}
      {/*        />*/}
      {/*      </div>*/}
      {/*    </div>*/}
      {/*    <a*/}
      {/*      href={`/${neighborhood.slug}`}*/}
      {/*      className="flex items-center w-auto pl-2 mt-4 uppercase cursor-pointer border-gold md:mt-8 md:mb-10 lg:my-6"*/}
      {/*    >*/}
      {/*      <div className="flex items-center border-b-2 border-gold">*/}
      {/*        <div className="w-5 h-4">*/}
      {/*          <Image*/}
      {/*            src={arrowLeft}*/}
      {/*            alt={`Learn more about ${neighborhood.name}`}*/}
      {/*            width={15}*/}
      {/*          />*/}
      {/*        </div>*/}
      {/*        <span className="pt-1">*/}
      {/*            Learn more about {neighborhood.name}*/}
      {/*          </span>*/}
      {/*      </div>*/}
      {/*    </a>*/}
      {/*  </section>*/}
      {/*)}*/}
      {nearbyCondosLoading && !nearbyCondos.length && (
        <section className="container pt-6 pb-2 md:pb-[43px] lg:pb-[69px] md:pt-[30px] container-carousel lg:pt-12 text-m">
          <Preloader />
        </section>
      )}
      {nearbyCondos.length > 0 && (
        <>
          <section className="container pt-1 mt-6 pb-[41px] md:pb-0 md:mb-2 lg:pb-[64px]">
            <p className="text-16-26-0.3 font-sohneKraftig md:text-20-28-0.3">
              See {nearbyCondosTotal || 0}
              &nbsp; Other Condos Available in&nbsp;
              {neighborhood.name}
            </p>
            <ResponsiveCarousel
              className="nearby-condos-carousel"
              containerClassName="relative mb-2 md:mb-4 lg:mb-14 mt-[27px]"
              arrowHeight={{
                mobile:
                  'absolute top-[50%] -translate-y-1/2 flex items-center px-3 md:px-3.5 xl:px-4 transition-colors',
                sm: 'absolute top-[50%] -translate-y-1/2 flex items-center px-3 md:px-3.5 xl:px-4 transition-colors',
                tablet:
                  'absolute top-[50%] -translate-y-1/2 flex items-center px-3 md:px-3.5 xl:px-4 transition-colors',
                desktop:
                  'absolute top-[50%] -translate-y-1/2 flex items-center px-3 md:px-3.5 xl:px-4 transition-colors',
                xl: 'absolute top-[50%] -translate-y-1/2 flex items-center px-3 md:px-3.5 xl:px-4 transition-colors',
              }}
            >
              {nearbyCondos
                ?.filter((it) => it.id !== listing.id)
                .map((item, index) => {
                  return (
                    <div key={item.id}>
                      <CondoCard
                        isIconPPC={isIconPPC}
                        isPPC={isPPC}
                        listing={item.attributes}
                        index={index}
                        showDeltaPrice={true}
                        carouselResponsivness={true}
                      />
                    </div>
                  );
                })}
            </ResponsiveCarousel>
            <div className="flex items-center justify-center mx-auto mt-16 md:w-1/2 lg:w-[366px] ">
              <Button
                href={createSearchUrlByType(
                  getPropertyTypeByCode(listing.propertyTypeCode),
                  {
                    neighborhoods: [neighborhood.slug],
                  }
                )}
                name="View more"
              />
            </div>
          </section>
          <LineBetweenSections hideLine={'container lg:pb-[4px]'} />
        </>
      )}
    </ErrorBoundary>
  );
};

export default AboutSection;
